export default __webpack_public_path__ + "static/media/closet4-480w.fc0873ae.png";